
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { type SubscriptionFormValues } from "./SubscriptionFormSchema";
import { Clock } from "lucide-react";

interface SubscriptionSessionsFieldProps {
  control: Control<SubscriptionFormValues>;
}

export function SubscriptionSessionsField({ control }: SubscriptionSessionsFieldProps) {
  const { t } = useTranslation(["subscriptions", "common"]);

  return (
    <FormField
      control={control}
      name="sessionsTotal"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="flex items-center">
            <Clock className="h-4 w-4 mr-2 text-amber-500" />
            {t('sessions.total')}
          </FormLabel>
          <FormControl>
            <Input
              type="number"
              min={0}
              {...field}
              onChange={(e) => field.onChange(Number(e.target.value))}
              className="transition-all focus-within:border-amber-500 focus-within:ring-amber-200"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
